import { Progress, Tooltip } from "antd";
import { useEffect, useState } from "react";
import _consumerService from "../../../modules/consumerService";

const ConsumerApplicationProgressBar = () => {
    const [completedPercent, setCompletedPercent] = useState(0);
    const applicationId = Number(localStorage.getItem("ApplicationObjId"));

    useEffect(() => {
        if (applicationId) {
            getApplicationStatusByApplicationId(applicationId);
        }
    }, [applicationId]);

    const getApplicationStatusByApplicationId = async (id) => {
        try {
            const res = await _consumerService.getApplicationStatusByApplicationId(id);
            if (res.data?.Obj?.applicationScreenStatus) {
                const status = res.data.Obj.applicationScreenStatus;
                const screens = getFilteredScreens();
                const screenMapping = getScreenKeyMapping();

                let completedCount = 0;

                // Count completed screens
                screens.forEach((screen) => {
                    const key = screenMapping[screen];
                    if (status[key] === true) {
                        completedCount += 1;
                    }
                });

                const percent = Math.round((completedCount / screens.length) * 100);
                setCompletedPercent(percent);
            }
        } catch (error) {
            console.error("Error fetching application status", error);
        }
    };

    // Maps screen names to API keys
    const getScreenKeyMapping = () => ({
        "Personal Details": "IsAapplicationDetailsCompleted",
        "Upload Documents": "IsDocumentUploadCompleted",
        "Income Source": "IsIncomesourceCompleted",
        "Expenses": "IsExpensesCompleted",
        "Balance Sheet Asset": "IsBalancesheetAssetCompleted",
        "Balance Sheet Total Asset": "IsBalancesheetTotalAssetCompleted",
        "Balance Sheet Total Liability": "IsBalancesheetTotalLiabiltyCompleted",
        "Questionnaire": "IsQuestionairCompleted"
    });

    const getFilteredScreens = () => {
        switch (true) {
            case true:
                return [
                    "Personal Details",
                    "Upload Documents",
                    "Income Source",
                    "Expenses",
                    "Balance Sheet Asset",
                    "Balance Sheet Total Asset",
                    "Balance Sheet Total Liability",
                    "Questionnaire"
                ];
            default:
                return [];
        }
    };

    return (
        <>
            <Tooltip title={`Application Workflow Progress: ${completedPercent}%`}>
                <Progress
                    // style={{ marginBottom: "2px", width: "250px" }}
                    style={{ marginBottom: "2px" }}
                    percent={completedPercent}
                    format={(percent) => `${percent}%`}
                />
            </Tooltip>
        </>
    );
};

export default ConsumerApplicationProgressBar;
